import { RouteRecordRaw } from "vue-router"
import { routePaths } from "../routePaths"
import { CX_CORE_FEATURES_ENUM, featureCheck } from "@/common/util/featuresUtil"

const prepareRoutes: RouteRecordRaw[] = [
  {
    path: "/prepare",
    name: "prepare",
    component: () => import("@/layout/AbstractRouteView.vue"),
    meta: {
      isProtected: true
    },
    children: [
      {
        path: `${routePaths.prepare.models.path}/:id?`,
        name: routePaths.prepare.models.pathName,
        component: () =>
          featureCheck(CX_CORE_FEATURES_ENUM.EDIT_MODELS)
            ? import("@/modules/prepare/pages/ModelsOverview.vue")
            : import("@/modules/error/PageNotFound.vue"),
        meta: {
          isProtected: true,
          navigation: [
            {
              title: "Prepare",
              translationKey: "sideMenu.prepare"
            },
            {
              title: "Models Overview",
              translationKey: "sideMenu.model",
              routeName: routePaths.prepare.models.pathName
            }
          ]
        }
      },
      {
        path: routePaths.prepare.mapping.path,
        name: routePaths.prepare.mapping.pathName,
        component: () =>
          featureCheck(CX_CORE_FEATURES_ENUM.CROSS_MAPPINGS)
            ? import("@/modules/prepare/pages/MappingOverview.vue")
            : import("@/modules/error/PageNotFound.vue"),
        meta: {
          isProtected: true,
          navigation: [
            {
              title: "Prepare",
              translationKey: "sideMenu.prepare"
            },
            {
              title: "Mapping",
              translationKey: "sideMenu.mapping",
              routeName: routePaths.prepare.mapping.pathName
            }
          ]
        }
      },
      {
        path: routePaths.prepare.converter.path,
        name: routePaths.prepare.converter.pathName,
        component: () =>
          featureCheck(CX_CORE_FEATURES_ENUM.CONVERTERS)
            ? import("@/modules/prepare/pages/ConvertersOverview.vue")
            : import("@/modules/error/PageNotFound.vue"),
        meta: {
          isProtected: true,
          navigation: [
            {
              title: "Prepare",
              translationKey: "sideMenu.prepare"
            },
            {
              title: "Converters Overview",
              translationKey: "sideMenu.converter",
              routeName: routePaths.prepare.converter.pathName
            }
          ]
        }
      }
    ]
  }
]

export default prepareRoutes
